import { ERROR_MESSAGES } from '@/utils/defaultErrorMsg'
import { z } from 'zod'

export const sendCallTokenSchema = z.object({
  externalAuthorizationToken: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
})
